import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "../lib/api";

/**
 * Redirects to / when a given section toggle is disabled in admin.
 */
export const SectionGuard = ({ section, children }) => {
  const [status, setStatus] = useState("loading"); // loading | enabled | disabled

  useEffect(() => {
    api.get("/admin/sections").then(({ data }) => {
      const found = data.find((s) => s.section === section);
      setStatus(found && found.enabled === false ? "disabled" : "enabled");
    }).catch(() => setStatus("enabled"));
  }, [section]);

  if (status === "loading") {
    return <div className="p-12 text-white/60">Chargement...</div>;
  }
  if (status === "disabled") {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default SectionGuard;
